import { useQuery } from '@tanstack/react-query';
import { getBranchMenus } from '@/api/getBranchMenus';
import { queryKeys } from '@/constants/queryKeys';

interface Params {
  brandId: string;
  kitchenId: string;
  pointOfSaleId: string;
  locale: string;
}

export const useBranchMenus = ({ brandId, kitchenId, pointOfSaleId, locale }: Params) => {
  const isCustomerMenuEnabled = Boolean(brandId && kitchenId && pointOfSaleId && locale);

  return useQuery({
    queryKey: queryKeys.branchMenus({ brandId, kitchenId, pointOfSaleId, language: locale }),
    queryFn: () => getBranchMenus(brandId, kitchenId, pointOfSaleId, locale),
    enabled: isCustomerMenuEnabled,
    staleTime: 1000 * 60 * 10, // 10 minutes - data stays fresh
    gcTime: 1000 * 60 * 10, // 10 minutes - data stays in cache even when unused
  });
};
